import Box from "@material-ui/core/esm/Box";
import Divider from "@material-ui/core/esm/Divider";
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValueLoadable } from 'recoil';
import { customerPrivilegesPagination, searchCustomerPrivileges } from 'api/privileges/getCustomerPrivileges';
import Pagination from 'components/Pagination/Pagination';
import Spinner from 'components/Spinner/Spinner';
import { BoldSubtitle, Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import checkLoadable from 'utils/recoil/checkLoadable';
import useStyles from './AccessStyles';
import PrivilegeRow from './PrivilegeRow';
export default function PrivilegeList() {
  const {
    customer
  } = useCurrentCustomer();
  const {
    privilege: privilegeClass,
    column,
    emailColumn,
    conditionalColumn
  } = useStyles();
  const {
    t
  } = useTranslation();
  const [pagination, setPagination] = useRecoilState(customerPrivilegesPagination);
  const privilegesLoadable = useRecoilValueLoadable(searchCustomerPrivileges(customer?.id));
  const {
    contents: privileges,
    loading
  } = checkLoadable(privilegesLoadable);
  if (loading) return /*#__PURE__*/React.createElement(Spinner, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Box, {
    mb: 3
  }, /*#__PURE__*/React.createElement(Title, {
    isBold: true
  }, t('access_management.users_with_access'))), /*#__PURE__*/React.createElement("div", {
    className: privilegeClass
  }, /*#__PURE__*/React.createElement("div", {
    className: clsx(column, emailColumn)
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('access_management.user_email'))), /*#__PURE__*/React.createElement("div", {
    className: clsx(column, conditionalColumn)
  }, /*#__PURE__*/React.createElement(BoldSubtitle, null, t('access_management.active_from')))), /*#__PURE__*/React.createElement(Divider, null), privileges?.results?.map(privilege => /*#__PURE__*/React.createElement("div", {
    key: privilege.id
  }, /*#__PURE__*/React.createElement(PrivilegeRow, {
    privilege: privilege
  }), /*#__PURE__*/React.createElement(Divider, null))), /*#__PURE__*/React.createElement(Pagination, {
    totalResults: privileges?.totalResults ?? 0,
    handlePagination: setPagination,
    paginationParams: pagination,
    rowsPerPageOptions: [5, 10, 30, 100]
  }));
}